module.exports = __webpack_public_path__ + "img/6.d1f729dd.png";